/**
 * useClipboard
 *
 * Composable for clipboard operations with user feedback via the UI store toast.
 * Replaces the `copyToClipboard` method from the global mixin.
 */
import { useUIStore } from '@/stores/ui'

export function useClipboard() {
  const uiStore = useUIStore()

  async function copyToClipboard(content: string): Promise<void> {
    try {
      await navigator.clipboard.writeText(content)
      uiStore.updateToast({
        open: true,
        message: 'Copied to the clipboard!',
        type: 'success',
      })
    } catch (error) {
      console.error('copyToClipboard failed:', error)
      uiStore.updateToast({
        open: true,
        message: 'Something went wrong',
        type: 'danger',
      })
    }
  }

  return { copyToClipboard }
}
